const appId = 'dt4Rp5mBqy0ROTxD7xOqupTswfEghxig'
const appSecret = 'zj2ft3HIPzM40zvkSswIsGJ7MNPMzyZU'
//const brand = 12
export const urls = {}
const targetHost = setEnv( 'production')  // 'production', 'staging', 'develop'
export default {
	methods: {
		getHeaders() {
			return {
				'Accept': 'application/json',
				'app-id': appId,
				'app-secret': appSecret,
				'Access-Control-Allow-Origin': '*',
				'X-Requested-With': 'XMLHttpRequest',
			}

		},
		getbrandId() {
			// api/app/brands/slug/{brand}
			// pita-pit,kawa-sushi,unoapp,blowfish-101
			// TODO: get brand ID by the brand names
			this.axios.get(targetHost + 'brands/slug/' + this.$route.params.brand, {
				headers: this.getHeaders()
			})
				.then(success => {
					// console.log(success)
					this.$emit('brandID', success)
				})
				.catch(function (error) {
					console.log(error)
				})
		},
		getBrandDetails() {
			this.axios.get(targetHost + 'brands/' + this.brand_id + '/show', {
				headers: this.getHeaders()
			})
				.then(success => {

					this.$emit('brand-details', success)
				})
				.catch(error => {
					this.$emit('brand-details', error)
				})
		},

		getLocations() {
			this.axios.get(targetHost + 'locations/search?nofilter=0&online_ordering=1&withhours=1&brand=' + this.brand_id, {
				headers: this.getHeaders()
			})
				.then(success => {

					this.$emit('locations', success)
				})
				.catch(error => {
					this.$emit('locations', error)
				})
		},


		getMenuCategory(id) {
			this.axios.get(targetHost + 'menus/menuUpToItems/' + id, {
				headers: this.getHeaders()
			})
				.then(success => {
					this.$emit('menu-category', success)
				})
				.catch(error => {
					this.$emit('menu-category', error.response.data)
				})
		},

		getItemDetail(id) {
			this.axios.get(targetHost + 'items/showfull/' + id, {
				headers: this.getHeaders()
			})
				.then(success => {
					this.$emit('item-detail', success)
				})
				.catch(error => {
					this.$emit('item-detail', error.response.data)
				})
		},

		createNewAccount(object) {
			this.axios.post(targetHost + 'user/register', object, {
				headers: this.getHeaders()
			})
				.then(success => {
					this.$emit('create-new-user', success)
				})
				.catch(error => {

					this.$emit('create-new-user', error.response.data)
				})
		},

		getBillingProfiles() {
			var headers = this.getHeaders()
			var user_session = localStorage.getItem('user_session');
			var parsedUserSession = JSON.parse(user_session);
			headers['auth-token'] = parsedUserSession.token

			this.axios.get(targetHost + 'user/getBillingProfile', {
				headers: this.getHeaders()
			})
				.then(success => {
					this.$emit('user-billing-profiles', success)
				})
				.catch(error => {
					console.log(error)
					//this.$emit('user-billing-profile', error.response.data)
				})
		},

		submitGuestCheckout(object) {
			this.axios.post(targetHost + 'order/place', object, {
				headers: this.getHeaders()
			})
				.then(success => {
					this.$emit('guest-checkout', success.data)
				})
				.catch(error => {
					this.$emit('guest-checkout', error.response.data)
				})
		},

		getLocationFromPlaceId(placeid) {
			this.axios.get(targetHost + 'locations/googlelocationdetail/' + placeid, {
				headers: this.getHeaders()
			})
				.then(success => {
					this.$emit('delivery-location-detail', success.data)
				})
				.catch(error => {
					this.$emit('delivery-location-detail', error.response.data)
				})
		},

		setBillingProfiles(object) {
			var headers = this.getHeaders()
			var user_session = localStorage.getItem('user_session');
			var parsedUserSession = JSON.parse(user_session);
			headers['auth-token'] = parsedUserSession.token
			this.axios.oist(targetHost + 'user/setBillingProfile', object, {
				headers: headers
			})
				.then(success => {
					this.$emit('set-user-profiles', success)
				})
				.catch(error => {
					console.log(error)
					//this.$emit('user-billing-profile', error.response.data)
				})

		},

		login(object) {
			object.brand_id = this.brand_id
			this.axios.post(targetHost + 'user/login', object)
				.then(success => {
					this.$emit('login', success.data)
					// set value in local storage
					if (success.data.status == 'ok') {
						localStorage.setItem("user_detail", JSON.stringify(success.data.payload));
						localStorage.setItem("user_session", JSON.stringify(success.data.session));
					}

				})
				.catch(error => {
					this.$emit('login', error.response.data)
				})
		},



    isUserLoggedIn() {
      var user_session = localStorage.getItem('user_session');
      if (user_session) {
        var userdetail = JSON.parse(user_session);
        if (userdetail.token) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    getEnvDetails () {
      console.log(targetHost)
      // production
      if (targetHost === 'https://ecomm.api.unoapp.io/api/app/') {
      let url = {
          monerisEndpoint: targetHost + 'user/generateMonerisToken',
          payeezy: {
            apiKey: 'nfupzlQTmO4j73SCOTga4cXsq3GRhEG1',
            jsSecurityKey: 'js-da8cea19f1a2bce3f1158c3be66bef97da8cea19f1a2bce3',
            endpoint: 'api.payeezy.com',
            keyDetails: targetHost + 'brands/' + this.brand_id + '/payment_gateway'
          },
          stripeDetails: {
            stripeUSKey: 'pk_live_efEYHQWcYMvHPX7B61DcAhfi',
            stripeCanadaKey: 'pk_live_YVfcFYNnJm9gZVSnC1HHxruL'
          },
          bamboraEndpoint: targetHost + 'user/generateBamboraToken',
          promocodeEndpoint: targetHost + 'promocodes/canApply',
          deliveryEndpoint: targetHost + 'delivery_profile/calculateDeliveryFee',
          testData: {
            contact: {
              first_name: '',
              last_name: '',
              phone: '',
              email: ''
            },
            card: {
              cardNo: '',
              cvv: '',
              month: '',
              year: ''
            }
          }
        }
       return url
     }
     // staging
     if(targetHost === 'https://ecomm.staging.api.unoapp.io/api/app/') {
           let url = {
               monerisEndpoint: targetHost + 'user/generateMonerisToken',
               payeezy: {
                 apiKey: 'nfupzlQTmO4j73SCOTga4cXsq3GRhEG1',
                 jsSecurityKey: 'js-da8cea19f1a2bce3f1158c3be66bef97da8cea19f1a2bce3',
                 endpoint: 'api.payeezy.com',
                 keyDetails: targetHost + 'brands/' + this.brand_id + '/payment_gateway'
               },
               stripeDetails: {
                 stripeUSKey: 'pk_test_o1aBWckozAE0xju1mTOUOuhj',
                 stripeCanadaKey: 'pk_test_0FHrvbS87h6ZFMm1nm8hXvi4'
               },
               bamboraEndpoint: targetHost + 'user/generateBamboraToken',
               promocodeEndpoint: targetHost + 'promocodes/canApply',
               deliveryEndpoint: targetHost + 'delivery_profile/calculateDeliveryFee',
               testData: {
                 contact: {
                   first_name: 'John',
                   last_name: 'Doe',
                   phone: '1234567890',
                   email: 'taylor@unoapp.com'
                 },
                 card: {
                   cardNo: '373599005095005',
                   cvv: '123',
                   month: '04',
                   year: '2019'
                 }
               }
             }
            return url
           }
        // develop
      if (targetHost === 'https://multivendor.dev.api.unoapp.io/api/app/') {
        let url = {
            monerisEndpoint: targetHost + 'user/generateMonerisToken',
            payeezy: {
              apiKey: 'nfupzlQTmO4j73SCOTga4cXsq3GRhEG1',
              jsSecurityKey: 'js-da8cea19f1a2bce3f1158c3be66bef97da8cea19f1a2bce3',
              endpoint: 'api-cert.payeezy.com',
              keyDetails: 'https://ecomm.api.unoapp.io/api/app/' + 'brands/' + this.brand_id + '/payment_gateway'
            },
            stripeDetails: {
              stripeUSKey: 'pk_test_o1aBWckozAE0xju1mTOUOuhj',
              stripeCanadaKey: 'pk_test_0FHrvbS87h6ZFMm1nm8hXvi4'
            },
            bamboraEndpoint: targetHost + 'user/generateBamboraToken',
            promocodeEndpoint: targetHost + 'promocodes/canApply',
            deliveryEndpoint: targetHost + 'delivery_profile/calculateDeliveryFee',
            testData: {
              contact: {
                first_name: 'John',
                last_name: 'Doe',
                phone: '1234567890',
                email: 'taylor@unoapp.com'
              },
              card: {
                cardNo: '373599005095005',
                cvv: '123',
                month: '04',
                year: '2019'
              }
            }
          }
          return url
      }
    }
  }
};
function setEnv (env) {
	if(env === 'production') {
		return 'https://ecomm.api.unoapp.io/api/app/'
	} else if(env === 'staging') {
		return 'https://ecomm.staging.api.unoapp.io/api/app/'
	} else if( env === 'develop') {
		return 'https://multivendor.dev.api.unoapp.io/api/app/'
	}
}



// WEBPACK FOOTER //
// ./src/global.js